<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="introclass">
      <div class="introclass__bg">
        <div class="introclass__bg-view">
          <!--
          <video
            id="indexEnterVideo"
            src="https://vod.plaync.com/LineageW/01_intro_f_0810.mp4"
            muted
            playsinline
          />-->

          <video
            id="classLoopVideo"
            src="https://vod.plaync.com/LineageW/01_Classloop_1_1920_q_an.mp4"
            muted
            playsinline
            loop
          />

          <!--
          <video
            id="indexLeaveVideo"
            src="https://vod.plaync.com/LineageW/01_intro_to_Book_f_0810.mp4"
            muted
            playsinline
          />-->
        </div>
      </div>
      <FrameBook></FrameBook>
      <div class="introclass__contents">
        <div class="introclass__txt">
          <div class="introclass__txt-bg"></div>
          <div class="introclass__txt-bl">
            <span class="bl--1"></span><span class="bl--2"></span
            ><span class="bl--3"></span>
            <hr class="bl--r" />
            <hr class="bl--l" />
          </div>
          <div class="introclass__txt-tit" v-html="$t('class.tit')"></div>
          <!--
          <hr class="introclass__txt-hr" />
          -->
          <div class="introclass__txt-desc" v-html="$t('class.desc')"></div>
          <div class="introclass__btn-con">
            <a
              :href="'/event/teasing/class?lang='+lang"
              class="introclass__btn introclass__btn--class"
              >{{ $t("menu.detail") }}</a
            >
            <!--
            <router-link
              to="/showcase"
              class="index__btn index__btn--showcase"
              >{{ $t("menu.showcase") }}</router-link
            >-->
          </div>
          <!--
          <a :href="notice.link" class="index__notice">{{ notice.title }}</a>
          -->
        </div>
      </div>
      <ScrollBtn></ScrollBtn>
    </section>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import BaseSection from "./mixins/BaseSection.js";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import ScrollBtn from "../components/ScrollBtn";
import promokit from "@/utils/promokit";

export default {
  name: "introclass",
  components: { FrameBook, ScrollBtn },
  mixins: [BaseSection],
  data() {
    return {
      name: "introclass",
      bg: null,
      indexLoopVideo: null,
      indexLeaveVideo: null,
      titMotion: null,
      introSpeed: 1,
      thumbPlayer: "",
      youtube: {
        ko: "7rftoidCYqo",
        en: "NI-StVML2Pk",
        ja: "DLRs5eL-TQw",
        zh: "rrytkGu268k",
      },
      device: promokit.util.getDevice(),
    };
  },
  computed: {
    ...mapState(["contentsData", "country", "lang"]),
    /*
    notice() {
      const notice = {
        link:
          "/" +
          this.country.toLowerCase() +
          "/" +
          this.contentsData.notice.link,
        title: this.contentsData.notice.title,
      };
      return notice;
    },*/
    /*
    <a :href="notice.link" class="index__notice">{{ notice.title }}</a>
    */
  },
  methods: {
    setMotion() {
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, 0.5, { opacity: 0,  ease: "power2.easeOut" });

      this.titMotion = new gsap.timeline({ paused: true });
      this.titMotion
        /*
        .addLabel("start")
        .from(this.$el.querySelector(`.${this.name}__logo`), 0.5, {
          scale: 1.2,
          autoAlpha: 0,
          ease: "power4.easeOut",
        })
        .addLabel("title")
        .fromTo(
          this.$el.querySelector(`.${this.name}__logo > div`),
          1,
          { autoAlpha: 1 },
          { autoAlpha: 0, ease: "expo.easeInOut" },
          "title"
        )*/
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--1`),
          0.4,
          { autoAlpha: 0, rotation: 190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--2`),
          0.4,
          { autoAlpha: 0, rotation: -190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--3`),
          0.4,
          { autoAlpha: 0, scale: 3 },
          { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--r`),
          0.4,
          { autoAlpha: 0, x: -30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--l`),
          0.4,
          { autoAlpha: 0, x: 30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-bg`),
          0.4,
          { autoAlpha: 0, y: -10 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-tit`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.4"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-desc`),
          0.4,
          { autoAlpha: 0, y: -30 },
          { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
          "title+=0.6"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__btn-con`),
          0.5,
          { autoAlpha: 0 },
          { autoAlpha: 1, ease: "expo.easeOut" },
          "title+=0.8"
        )
        .fromTo(
          this.$el.querySelector(`.scroll-btn`),
          0.5,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.9"
        );
    },
    enter(el, done) {
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", () => {
        done();
        this.setIsMovePage(false);
      });
      if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);
    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
    },
    start() {
      this.enterMotion.play();
      this.titMotion.play();
    },
  },
  mounted() {
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }
    this.indexLoopVideo = document.querySelector("#classLoopVideo");
    this.indexLoopVideo.play();
  },
};
</script>

<style lang="scss">
.introclass {
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    // opacity: 0;
    // display: none;
    &-view {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      //@include bg($bg: "../assets/img/thumbnail-imsi.png");
      //background-size: contain;
      &::after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-color: rgba($color: black, $alpha: 0.1);
        position: absolute;
        left: 0;
        top: 0;
      }
      video {
        min-width: 100% !important;
        min-height: 100% !important;
        width: auto;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &#indexLeaveVideo {
          display: none;
        }
      }
    }
  }
  &__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    width: 100%;
    height: 100%;
    //  background: #f0f;
  }
  &__txt {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 563px,
      $top: 50%,
      $left: 50%
    );
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
    }
    margin-top: -416px;
    /*
    .ja &,
    .zh &,
    .en & {
      margin-top: -410px;
    }*/

    &-bl {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 157px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }
    &-tit {
      @include position(
        $position: absolute,
        $width: 583px,
        $height: 133px,
        $top: 198px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/ko/class_title.png", $cover: cover);
      @include hide-text;
      .en & {
        @include bg($bg: "../assets/img/en/class_title_en.png", $cover: cover);
        top: 191px;
      }
      .ja & {
        @include bg($bg: "../assets/img/ja/class_title_ja.png", $cover: cover);
      }
      .zh & {
        @include bg($bg: "../assets/img/zh/class_title_zh.png", $cover: cover);
      }
    }
    &-hr {
      border: none;
      @include position(
        $position: absolute,
        $width: 467px,
        $height: 37px,
        $top: 431px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_line.png");
      .en &,
      .zh &,
      .ja & {
        top: 386px;
      }
    }
    &-desc {
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 332px,
        $left: 50%
      );
      font-size: 19px;
      text-align: center;
      letter-spacing: -0.9px;
      line-height: 1.8em;
      opacity: 0.5;
      &::before {
        display: inline-block;
        content: "";
        @include position(
          $position: absolute,
          $width: 583px,
          $height: 212px,
          $top: -83px,
          $left: 50%
        );
        background: url("../assets/img/sub_bg_long.png");
        background-size: contain;
        z-index: -1;
        .ja &,
        .zh & {
          background: url("../assets/img/sub_bg_short.png");
        }
      }
      .zh &,
      .en & {
        letter-spacing: 0px;
      }
      .en &,
      .ja &,
      .zh & {
        top: 320px;
      }
    }
  }
  &__notice {
    @include position(
      $position: absolute,
      $width: 100%,
      $top: 462px,
      $left: 50%
    );
    text-align: center;
    font-size: 15px;
    color: #bdb6a6;
    &:hover {
      text-decoration: underline;
      color: #bdb6a6;
    }
    &:before {
      vertical-align: middle;
      display: inline-block;
      width: 24px * 0.65;
      height: 30px * 0.65;
      margin-right: 10px;
      @include bg($bg: "../assets/img/icon_notice.png", $cover: cover);
      content: "";
    }
    .en &,
    .ja &,
    .zh & {
      top: 416px;
    }
  }
  &__btn-con {
    @include position(
      $position: absolute,
      $width: 100%,
      $top: 508px,
      $left: 50%
    );
    text-align: center;
  }
  &__btn {
    @include position($position: relative, $width: 230px, $height: 93px);
    @include hide-text;
    display: inline-block;
    margin: 0;
    background-size: 230px auto;
    &:after {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 0
      );
      content: "";
      background-size: 230px auto;
      opacity: 0;
      transition: 0.3s;
      background-position-y: -104px !important;
    }

    &:hover {
      &:after {
        opacity: 1;
        transition: 0.3s;
      }
    }
    &--class {
      & {
        @include bg($bg: "../assets/img/ko/index_btn_class.png");
        &:after {
          @include bg($bg: "../assets/img/ko/index_btn_class.png");
        }
      }
      .en & {
        @include bg($bg: "../assets/img/en/index_btn_class_en.png");
        &:after {
          @include bg($bg: "../assets/img/en/index_btn_class_en.png");
        }
      }
      .ja & {
        @include bg($bg: "../assets/img/ja/index_btn_class_ja.png");
        &:after {
          @include bg($bg: "../assets/img/ja/index_btn_class_ja.png");
        }
      }
      .zh & {
        @include bg($bg: "../assets/img/zh/index_btn_class_zh.png");
        &:after {
          @include bg($bg: "../assets/img/zh/index_btn_class_zh.png");
        }
      }
    }
    &--showcase {
      .ko & {
        @include bg($bg: "../assets/img/ko/index_btn_showcase.png");
      }
      &:after {
        @include bg($bg: "../assets/img/ko/index_btn_showcase.png");
        background-position-y: -140px;
      }
      .en & {
        @include position(
          $position: relative,
          $width: 291px * 0.78,
          $height: 93px * 0.78
        );
        background-size: 291px * 0.78 auto;
        @include bg($bg: "../assets/img/en/index_btn_showcase_en.png");
        &:after {
          background-size: 291px * 0.78 auto;
          @include bg($bg: "../assets/img/en/index_btn_showcase_en.png");
        }
      }
      .ja & {
        @include bg($bg: "../assets/img/ja/index_btn_showcase_ja.png");
        &:after {
          @include bg($bg: "../assets/img/ja/index_btn_showcase_ja.png");
          background-position-y: -140px;
        }
      }
      .zh & {
        @include bg($bg: "../assets/img/zh/index_btn_showcase_zh.png");
        &:after {
          @include bg($bg: "../assets/img/zh/index_btn_showcase_zh.png");
          background-position-y: -140px;
        }
      }
    }
  }
  &__movie-con {
    @include position(
      $position: absolute,
      $width: 426px,
      $height: 240px,
      $bottom: 0,
      $right: 0
    );
    //@include bg($bg: "../assets/img/ko/banner_coming_soon.png", $cover: cover);
    z-index: 10;
    .promokit-youtube,
    .promokit-youtube__screen-wrap {
      width: 426px;
      height: 240px;
    }
    .promokit-youtube__bg {
      display: none;
    }
  }
  &__movie-mobile-layer {
    pointer-events: all;
    @include position(
      $position: absolute,
      $width: 100%,
      $height: auto,
      $top: 0px,
      $right: 0px,
      $bottom: 0px,
      $left: 0px
    );
    z-index: 10;
  }
  &__movie-close {
    @include position(
      $position: absolute,
      $width: 48px,
      $height: 48px,
      $top: 4px,
      $right: 4px
    );
    @include bg($bg: "../assets/img/icon_video_x.png", $cover: cover);
    z-index: 11;
  }
  &__movie-layer {
    pointer-events: all;
    @include position(
      $position: absolute,
      $width: 48px,
      $height: 48px,
      $top: 5px,
      $right: 48px
    );
    @include bg($bg: "../assets/img/icon_video_y.png", $cover: cover);
    z-index: 11;
  }

  @include bp(tablet) {
    // @include bg($bg: '../assets/img/index_guide_m.jpg');
    // background-size: 100% auto;
    &__bg {
      min-height: auto;
      &-view {
        video {
          height: 100%;
        }
      }
    }
    &__logo {
      @include position(
        $position: absolute,
        $width: 820px * 0.42,
        $height: 270px * 0.42,
        $top: 40px,
        $left: 50%
      );
      margin-top: 0;
    }
    &__txt {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 563px/2,
        $top: 50%,
        $left: 50%
      );
      margin-top: -230px;

      &-bg {
        display: none;
        /*
        @include position(
          $position: absolute,
          $width: 100%,
          $height: 100%,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
        background-size: 360px auto;
        */
      }

      &-bl {
        display: none;
        /*
        top: 47px;
        transform: scale(0.5);
        */
      }
      &-tit {
        @include position(
          $position: absolute,
          $width: 800px * 0.45,
          $height: 63px,
          $top: 60px,
          $left: 50%
        );
        .en & {
          /*
          @include position(
            $position: absolute,
            $width: 800px * 0.45,
            $height: 192px * 0.45,
            $top: 75px,
            $left: 50%
          );
          
          @include bg(
            $bg: "../assets/img/en/index_title_en_m.png",
            $cover: cover
          );*/
          top: 75px;
        }
        .ja & {
          @include position(
            $position: absolute,
            $width: 800px * 0.45,
            $height: 157px * 0.45,
            $top: 59px,
            $left: 50%
          );
        }
        .zh & {
          @include position(
            $position: absolute,
            $width: 800px * 0.45,
            $height: 157px * 0.45,
            $top: 59px,
            $left: 50%
          );
        }
      }
      &-hr {
        @include position(
          $position: absolute,
          $width: 200px,
          $height: 20px,
          $top: 185px,
          $left: 50%
        );
        background-size: cover;
        .en & {
          top: 215px;
        }
        .ja & {
          top: 185px;
        }
        .zh & {
          top: 163px;
        }
      }
      &-desc {
        top: 132px;
        font-size: 12px;
        text-align: center;
        letter-spacing: 0px;
        line-height: 1.8em;
        opacity: 0.5;
        &::before {
          @include position(
            $position: absolute,
            $width: 100%,
            $height: 100%,
            $top: 0,
            $left: 50%
          );
          @include bg($bg: "../assets/img/sub_bg_long.png", $position: 50% 0);
          background-size: 360px auto;
          //display: none;
        }
        .en & {
          top: 160px;
        }
        .ja &,
        .zh & {
          top: 129px;
        }
      }
    }
    &__notice {
      top: 200px;
      font-size: 12px;
      &:before {
        width: 24px * 0.5;
        height: 30px * 0.5;
        margin-right: 5px;
      }
      .en & {
        top: 230px;
      }
      .ja & {
        top: 201px;
      }
      .zh & {
        top: 179px;
      }
    }
    &__btn-con {
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 216px,
        $left: 50%
      );
      text-align: center;
      .en & {
        top: 266px;
      }
      .ja & {
        top: 227px;
      }
      .zh & {
        top: 205px;
      }
    }
    &__btn {
      @include position(
        $position: relative,
        $width: 390px * 0.5,
        $height: 137px * 0.5
      );
      background: url(../assets/img/ko/index_btn_class_m.png);
      background-size: 390px * 0.5 auto;
      &:after {
        display: none;
      }
      .en & {
        background: url(../assets/img/en/index_btn_class_m_en.png);
        background-size: 390px * 0.5 auto;
      }
      .ja & {
        background: url(../assets/img/ja/index_btn_class_m_ja.png);
        background-size: 390px * 0.5 auto;
      }
      .zh & {
        background: url(../assets/img/zh/index_btn_class_m_zh.png);
        background-size: 390px * 0.5 auto;
      }
    }
    &__movie-con {
      @include position(
        $position: absolute,
        $width: 156px,
        $height: 88px,
        $bottom: 0,
        $right: 0
      );
      .promokit-youtube,
      .promokit-youtube__screen-wrap {
        width: 156px;
        height: 88px;
      }
    }
    &__movie-close {
      @include position(
        $position: absolute,
        $width: 30px,
        $height: 30px,
        $top: 4px,
        $right: 4px
      );
    }
    &__movie-layer {
      display: none;
    }
  }
  @include bp(mobile) {
    &__movie-con {
      .promokit-youtube {
        min-width: auto;
        width: 156px;
        height: 88px;
      }
    }
    /*
    &__txt {
      top: auto;
      bottom: 91px;

      .en & {
        bottom: 131px;
      }
      .zh & {
        bottom: 69px;
      }
    }*/
  }
  @media (max-width: 960px) and (min-aspect-ratio: 1920/1080) {
    &__bg {
      &-view {
        video {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
